<template>
<v-container ma-0 pa-0 fluid style="height:100%;" class="pt-sans conteudo-relat-pedidos">
   <v-layout row wrap class="bcg">
        <v-flex xs12 sm1>
          <div>
            <p style="margin:19px 0 0 0;"><strong> Período: </strong></p>
          </div>
        </v-flex>

      <v-flex xs12 sm2 md2>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="computedDateFormattedFrom"
                label="De"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker locale="pt-br" v-model="dateFrom" @input="menu = false"></v-date-picker>
          </v-menu>
        </v-flex>
        
      <v-flex xs12 sm2 md2 spacing>
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="computedDateFormattedTo"
                label="Até"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker locale="pt-br" v-model="dateTo" @input="menu2 = false"></v-date-picker>
          </v-menu>
        </v-flex>
   
        <v-flex xs12 sm3 spacing>
          <v-select
            v-model="selectedStatus"
            :items="statusName"
            chips
            label="Selecione os status"
            multiple
            outline
          ></v-select>
        </v-flex>

        <v-flex xs12 sm3 spacing>
          <v-select
            v-model="selectedFornecedores"
            :items="fornecedoresDescription"
            chips
            label="Selecione os fornecedores"
            multiple
            outline
          ></v-select>
        </v-flex>
        
        <v-flex sm1>
          <v-btn @click="pesquisar" large color="primary" block dark >  <v-icon>search</v-icon></v-btn>
        </v-flex>

        <v-flex xs12 s12 justify-right botoes-relatorio >
          <v-btn large color="primary" dark @click="exportToCsv" spacing><v-icon>get_app</v-icon>  Exportar para excel </v-btn>
           <v-btn large color="primary" dark @click="prepareData('export')" spacing><v-icon>archive</v-icon>   Exportar para PDF </v-btn>
          <v-btn large color="primary" dark @click="prepareData('print')">  <v-icon>print</v-icon>   Imprimir</v-btn>
        </v-flex>

        <v-flex xs12 s12>
          <v-card>
            <v-card-title>
              Pedidos
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="busca por texto ..."
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              v-bind:pagination.sync="pagination"
              :headers="headers"
              :items="pedidosReport"
              :search="search"
            >
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.data }}</td>
                <td class="text-xs-left">{{ props.item.nro }}</td>
                <td class="text-xs-left">{{ props.item.itens }}</td>
                <td class="text-xs-left">{{ props.item.qtd }}</td>
                <td class="text-xs-left">{{ props.item.fornecedor }}</td>
                <td class="text-xs-left">{{ props.item.condominio }}</td>
                <td class="text-xs-left">{{ props.item.adm }}</td>
                <td class="text-xs-left">{{ props.item.morador }}</td>
                <td class="text-xs-left">{{ props.item.phone }}</td>
                <td class="text-xs-left">{{ props.item.email }}</td>
                <td class="text-xs-left">{{ props.item.unidade }}</td>
                <td class="text-xs-right">{{ props.item.valor }}</td>
              </template>
              <template v-slot:no-results>
                <v-alert :value="true" color="error" icon="warning">
                  Sua pesquisa "{{ search }}" não encontrou resultados.
                </v-alert>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
        <v-spacer></v-spacer>
  </v-layout>
</v-container>
</template>

<script>
import * as jsPDF from 'jspdf'
const PDFMaker = jsPDF
import 'jspdf-autotable'
import { mapActions, mapGetters } from 'vuex'
import XLSX from 'xlsx'

export default {
  computed: {
    ...mapGetters('report', ['fornecedores', 'pedidosReport', 'statusName', 'fornecedores', 'fornecedoresDescription', 'statusOrder']),
    status () {
      return this.$store.getters.toastr
    },
    computedDateFormattedFrom () {
      return this.formatDate(this.dateFrom)
    },
    computedDateFormattedTo () {
      return this.formatDate(this.dateTo)
    }
  },
  watch: {
    dateFrom (val) {
      this.dateFromFormated = this.formatDate(this.dateFrom)
    },
    dateTo (val) {
      this.dateFromFormated = this.formatDate(this.dateTo)
    }
  },
  data () {
    return {
      pagination: {'sortBy': 'data', 'descending': true, 'rowsPerPage': -1},
      selectedStatus: [],
      selectedFornecedores: [],
      listIds: [],
      listEnums: [],
      dateFrom: new Date().toISOString().substr(0, 10),
      dateFromFormated: this.formatDate(new Date().toISOString().substr(0, 10)),
      dateTo: new Date().toISOString().substr(0, 10),
      dateToFormated: this.formatDate(new Date().toISOString().substr(0, 10)),
      menu: false,
      menu2: false,
      search: '',
      message: '',
      headers: [
        { text: 'Data', value: 'data', align: 'left' },
        { text: 'Nro Ped.', value: 'nro', align: 'left' },
        {
          text: 'Item',
          align: 'center',
          sortable: false,
          value: 'name'
        },
        { text: 'Qtde', value: 'qtd', align: 'left' },
        { text: 'Fornecedor', value: 'fornecedor', align: 'left' },
        { text: 'Condomínio', value: 'condominio', align: 'left' },
        { text: 'ADM', value: 'adm', align: 'left' },
        { text: 'Cliente', value: 'morador', align: 'left' },
        { text: 'Tel', value: 'phone', align: 'left' },
        { text: 'Email', value: 'email', align: 'left' },
        { text: 'Unidade', value: 'unidade', align: 'left' },
        { text: 'Valor (R$)', value: 'valor', align: 'center' }
      ]
    }
  },
  methods: {
    ...mapActions('report', ['getOrdersReport', 'getStatusRelatorio', 'getBusinessPartner', 'resetPedidos']),
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    exportToCsv () {
      if (this.pedidosReport.length > 0) {
        var ws = XLSX.utils.json_to_sheet(this.pedidosReport)
        var wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, 'Pedidos')
        XLSX.writeFile(wb, 'pedidos.xlsx')
      }
    },
    prepareData (type) {
      var doc = new PDFMaker()
      let columns = [
        {title: 'Data', dataKey: 'data'},
        {title: 'Nro', dataKey: 'nro'},
        {title: 'Itens', dataKey: 'itens'},
        {title: 'Qtd', dataKey: 'qtd'},
        {title: 'Fornecedor', dataKey: 'fornecedor'},
        {title: 'Condômino', dataKey: 'morador'},
        {title: 'Unidade', dataKey: 'unidade'},
        {title: 'E-mail', dataKey: 'email'},
        {title: 'Telefone', dataKey: 'phone'},
        {title: 'Valor', dataKey: 'valor'}
      ]
      let rows = this.pedidosReport
      doc.autoTable(columns, rows, {
        margin: {top: 10},
        columnStyles: {
          data: {cellWidth: 25},
          nro: {cellWidth: 20},
          itens: {cellWidth: 45},
          qtd: {cellWidth: 10},
          fornecedor: {cellWidth: 25},
          morador: {cellWidth: 20},
          unidade: {cellWidth: 15},
          email: {cellWidth: 25},
          phone: {cellWidth: 15},
          valor: {cellWidth: 25}
        }})
      if (type === 'export') this.exportToPdf(doc)
      else if (type === 'print') this.printData(doc)
    },
    exportToPdf (doc) {
      doc.save('pedidos.pdf')
    },
    printData (doc) {
      doc.autoPrint()
      doc.output('dataurlnewwindow')
    },
    async pesquisar () {
      if (!this.valida()) {
        this.$store.commit('toastr', {
          color: 'error',
          texto: this.message
        })
      } else {
        // this
        const enums = this.getStatusEnum()
        const ids = this.getIds()
        const payload = {
          from: this.dateFrom,
          to: this.dateTo,
          fornecedores: ids,
          status: enums
        }
        this.getOrdersReport(payload)
      }
    },
    getStatusEnum () {
      let enums = this.statusOrder.filter(f => {
        if (this.selectedStatus.includes(f.name)) {
          return f.enums
        }
      })
      return enums.map(elem => {
        return elem.enums
      })
    },
    getIds () {
      let ids = this.fornecedores.filter(f => {
        if (this.selectedFornecedores.includes(f.name)) {
          return f.id
        }
      })
      return ids.map(elem => {
        return elem.id
      })
    },
    valida () {
      let valid = true
      if (this.dateFrom === null) {
        this.message = 'A data "De" está inválida'
        return false
      }
      if (this.dateTo === null) {
        this.message = 'A data "Até" está inválida'
        return false
      }
      if (this.selectedStatus.length === 0) {
        this.message = 'Selecione pelo menos um status do pedido'
        return false
      }
      if (this.selectedFornecedores.length === 0) {
        this.message = 'Selecione pelo menos um fornecedor'
        return false
      }
      if (this.dateFrom > this.dateTo) {
        this.message = 'A data "Até" não pode ser maior que a data "De"'
        return false
      }
      const date1 = new Date(this.dateTo)
      const date2 = new Date(this.dateFrom)
      const diffTime = Math.abs(date1.getTime() - date2.getTime())
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      if (diffDays >= 180) {
        this.message = 'O limite de pesquisa é semestral'
        return false
      }
      return valid
    }
  },
  async mounted () {
    // this.resetPedidos()
    this.getStatusRelatorio()
    this.getBusinessPartner()
  }

}
</script>

<style scoped>

.bcg {
  background-color: #f5f5f5;
}

.spacing {
  padding-right: 2%;
}

.texto {
  position: relative !important;
  height: 100%;
}

.content {
  position: absolute !important;
  bottom: 10%;
  right: 10%;
}

.text-rigth {
  text-align: right;
  padding-right: 4%;
}


.conteudo-relat-pedidos{
      height: 100%;
    width: 83%;
    margin: 0 auto!important;
}


.flex.xs12, .flex.sm1, .bcg{
  background: #fff;
}


.botoes-relatorio{
  float: left;
  margin-bottom: 30px;
  margin-top: -10px;
}

.v-text-field--outline > .v-input__control > .v-input__slot, .v-input__control{
  min-height: 10px!important;
  height: 10px!important;
}


.v-text-field.v-text-field--enclosed .v-text-field__details, .v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
    height: 15px!important;
}

</style>


// WEBPACK FOOTER //
// index.vue?d8aadf9e